export default __webpack_public_path__ + "static/11_difference-61d3b316542ebbd380030359b48a30f9.png";